import { axiosInstance as request } from '@/api/rest.service'
import axios from 'axios'

export const getChartData = name => request.get(`/charts/${name}`)
export const getChartDataForFinancialPeriod = (financialPeriodId, name) =>
  request.get(`/charts/${name}?financial_period_id=${financialPeriodId}`)

export const getTableData = financialPeriodId => {
  return request.get(`/departments/spend-overview?financial_period_id=${financialPeriodId}`)
}

export const getSharePerDepartment = (params, financial_period_id, depName) =>
  request.get(`/charts/share-per-department/underlying-data?paginated=true`, {
    params: {
      ...params,
      financial_period_id,
      department_name: depName
    }
  })

export const getDepartmentSpendOverview = (id = null) => {
  const param = id === null ? '' : id
  return request.get(`/info-boxes/department-spend-overview/${param}`)
}

export const getDepartments = () => request.get('/departments')

export const getDepsAndTableData = (id = null) => {
  return axios.all([getDepartmentSpendOverview(id), getDepartments()]).then(
    axios.spread((req1, req2) => {
      return { tableData: req1.data.result, deps: req2.data.result }
    })
  )
}
